export class SimpControlNames {

    public static facturationEtat: string = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepSep_ClasseProfit_SepAtt_region';
    public static facturationSiret: string = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepAtt_siret';
    public static indexationDateFinDiffusion = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_TypeIndexation_SepAtt_dateFinDiffusion';
    public static adr3: string = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_FNSimple_SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepAtt_adr3';

    public static getCtrl_1206Names_json(): any {
        const motsClef = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_TypeIndexation_SepSep_TypeMotsClef_SepAtt_motClef';
        return { motsClef: motsClef };
    }

    public static getCtrl_1222Names_json(): any {
        return { etat: SimpControlNames.facturationEtat, siret: SimpControlNames.facturationSiret };
    }

    public static getCtrl_facturationNames_json(): any {
        return { etat: SimpControlNames.facturationEtat, siret: SimpControlNames.facturationSiret };
    }

    public static getCtrl_9202Names_json(): any {
        return { firstChamp: SimpControlNames.indexationDateFinDiffusion };
    }

    public static getCtrl_TrimNames_json(): any {
        return { text: SimpControlNames.adr3 };
    }
}
